import React from 'react';
import { Button, Popover, PopoverBody } from 'reactstrap';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class JobNotesPopoverButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
        };
    }

    togglePopover = () => {
        const { showPopover } = this.state;

        this.setState({ showPopover: !showPopover });
    };

    render() {
        const { job } = this.props;
        const notes = job?.notes;

        if (!job || !notes) {
            return null;
        }

        const { showPopover } = this.state;

        return (
            <>
                <Button
                    id={`job-notes-${job.id}`}
                    color="info"
                    className="p-1 ml-2 mr-2 align-baseline"
                    type="button"
                    title="Published Notes"
                    onClick={this.togglePopover}
                    outline
                >
                    <FontAwesomeIcon icon={faInfoCircle} /> Notes
                </Button>
                <Popover
                    isOpen={showPopover}
                    target={`job-notes-${job.id}`}
                    toggle={this.togglePopover}
                    placement="auto-start"
                >
                    <PopoverBody>
                        <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
                    </PopoverBody>
                </Popover>
            </>
        );
    }
}
